export const GET_APP_CONFIGS_SUCCESS_NO_UPDATE = 'GET_APP_CONFIGS_SUCCESS_NO_UPDATE';
export const GET_APP_CONFIGS_ERROR = 'GET_APP_CONFIGS_ERROR';
export const GET_SITEMAP_DATA = 'GET_SITEMAP_DATA';
export const GET_SITEMAP_DATA_SUCCESS = 'GET_SITEMAP_DATA_SUCCESS';
export const GET_SITEMAP_DATA_ERROR = 'GET_SITEMAP_DATA_ERROR';
export const GET_BRAND_PAGE_CONTENT = 'GET_BRAND_PAGE_CONTENT';
export const BRAND_PAGE_CONTENT_API_SUCCESS = 'BRAND_PAGE_CONTENT_API_SUCCESS';
export const BRAND_PAGE_CONTENT_API_ERROR = 'BRAND_PAGE_CONTENT_API_ERROR';
export const UPDATE_LINE_ITEM = 'UPDATE_LINE_ITEM';
export const SET_USER_LAST_ACTIVE_TIME = 'SET_USER_LAST_ACTIVE_TIME';
export const GUEST_CUSTOMER_INFO = 'GUEST_CUSTOMER_INFO';
export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_FAILURE = 'SUBMIT_FEEDBACK_FAILURE';
export const RESET_CART_REDUCER = 'RESET_CART_REDUCER';
export const POST_ORDER_ACCEPTED = 'POST_ORDER_ACCEPTED';
export const POST_ORDER_ACCEPTED_ERROR = 'POST_ORDER_ACCEPTED_ERROR';
export const POST_ORDER_ACCEPTED_SUCCESS = 'POST_ORDER_ACCEPTED_SUCCESS';
export const ADD_HOPE_PAY_ACCEPTED = 'ADD_HOPE_PAY_ACCEPTED';
export const ADD_HOPE_PAY_ACCEPTED_SUCCESS = 'ADD_HOPE_PAY_ACCEPTED_SUCCESS';
export const ADD_HOPE_PAY_ACCEPTED_FAILURE = 'ADD_HOPE_PAY_ACCEPTED_FAILURE';
export const GIFT_CARD_PURCHASE = 'GIFT_CARD_PURCHASE';
export const GIFT_CARD_PURCHASE_SUCCESS = 'GIFT_CARD_PURCHASE_SUCCESS';
export const GIFT_CARD_PURCHASE_ERROR = 'GIFT_CARD_PURCHASE_ERROR';
export const RESET_POST_ORDER = 'RESET_POST_ORDER';
export const SYNC_CONTENTFUL_DATA = 'SYNC_CONTENTFUL_DATA';
export const SYNC_CONTENTFUL_DATA_SUCCESS = 'SYNC_CONTENTFUL_DATA_SUCCESS';
export const SYNC_CONTENTFUL_DATA_FAILURE = 'SYNC_CONTENTFUL_DATA_FAILURE';
export const MARKETING_PREFERENCE = 'MARKETING_PREFERENCE';
export const MARKETING_PREFERENCE_SUCCESS = 'MARKETING_PREFERENCE_SUCCESS';
export const MARKETING_PREFERENCE_FAILURE = 'MARKETING_PREFERENCE_FAILURE';
export const CONTENTFUL_ENTRY = 'CONTENTFUL_ENTRY';
export const CONTENTFUL_ENTRY_SUCCESS = 'CONTENTFUL_ENTRY_SUCCESS';
export const CONTENTFUL_ENTRY_FAILURE = 'CONTENTFUL_ENTRY_FAILURE';
export const GET_FAQ = 'GET_FAQ';
export const GET_FAQ_ERROR = 'GET_FAQ_ERROR';
export const GET_FAQ_SUCCESS = 'GET_FAQ_SUCCESS';
export const GET_CONTACT_US = 'GET_CONTACT_US';
export const GET_CONTACT_US_ERROR = 'GET_CONTACT_US_ERROR';
export const GET_CONTACT_US_SUCCESS = 'GET_CONTACT_US_SUCCESS';
export const GET_DELIVERY_AGGREGATOR = 'GET_DELIVERY_AGGREGATOR';
export const GET_DELIVERY_AGGREGATOR_ERROR = 'GET_DELIVERY_AGGREGATOR_ERROR';
export const GET_DELIVERY_AGGREGATOR_SUCCESS = 'GET_DELIVERY_AGGREGATOR_SUCCESS';
export const GET_TERMS_OF_USE = 'GET_TERMS_OF_USE';
export const TERMS_OF_USE_ERROR = 'TERMS_OF_USE_ERROR';
export const TERMS_OF_USE_SUCCESS = 'TERMS_OF_USE_SUCCESS';
export const GET_PROTECTED_DISCLOSURE = 'GET_PROTECTED_DISCLOSURE';
export const PROTECTED_DISCLOSURE_ERROR = 'PROTECTED_DISCLOSURE_ERROR';
export const PROTECTED_DISCLOSURE_SUCCESS = 'PROTECTED_DISCLOSURE_SUCCESS';
export const GET_NUTRITION_ALLERGEN_DISCLAIMER = 'GET_NUTRITION_ALLERGEN_DISCLAIMER';
export const NUTRITION_ALLERGEN_DISCLAIMER_ERROR = 'NUTRITION_ALLERGEN_DISCLAIMER_ERROR';
export const NUTRITION_ALLERGEN_DISCLAIMER_SUCCESS = 'NUTRITION_ALLERGEN_DISCLAIMER_SUCCESS';
export const COUPON_COPY = 'COUPON_COPY';
export const REDEEM_COUPON_COPY = 'REDEEM_COUPON_COPY';
export const SET_NAVIGATE_TO = 'SET_NAVIGATE_TO';
export const RESET_NAVIGATE_TO = 'RESET_NAVIGATE_TO';
export const SET_HAND_IT_TO_ME_STATUS = 'SET_HAND_IT_TO_ME_STATUS';
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';
export const CART_ITEMS_LIST_NAME = 'CART_ITEMS_LIST_NAME';
export const DELETE_SAVED_ADDRESS = 'DELETE_SAVED_ADDRESS';
export const DELETE_SAVED_CARD = 'DELETE_SAVED_CARD';
export const DELETE_SAVED_CARD_FAILURE = 'DELETE_SAVED_CARD_FAILURE';
export const DELETE_SAVED_CARD_SUCCESS = 'DELETE_SAVED_CARD_SUCCESS';
export const PAYMENT_FOR_ADDHOPE = 'PAYMENT_FOR_ADDHOPE';
export const PAYMENT_FOR_ADDHOPE_SUCCESS = 'PAYMENT_FOR_ADDHOPE_SUCCESS';
export const PAYMENT_FOR_ADDHOPE_FAILURE = 'PAYMENT_FOR_ADDHOPE_FAILURE';
export const GET_PAST_ORDER = 'GET_PAST_ORDER';
export const GET_PAST_ORDER_SUCCESS = 'GET_PAST_ORDER_SUCCESS';
export const GET_PAST_ORDER_FAILURE = 'GET_PAST_ORDER_FAILURE';
export const CLEAR_PAST_ORDER = 'CLEAR_PAST_ORDER';
export const GET_PAYTM_TOKEN_CALL = 'GET_PAYTM_TOKEN_CALL';
export const GET_PAYTM_TOKEN_SUCCESS = 'GET_PAYTM_TOKEN_SUCCESS';
export const GET_PAYTM_TOKEN_FAILED = 'GET_PAYTM_TOKEN_FAILED';
export const REMOVE_ALL_COUPONS = 'REMOVE_ALL_COUPONS';
export const REMOVE_ALL_COUPONS_SUCCESS = 'REMOVE_ALL_COUPONS_SUCCESS';
export const REMOVE_ALL_COUPONS_FAILURE = 'REMOVE_ALL_COUPONS_FAILURE';
export const SET_FAVOURITE_ORDER = 'SET_FAVOURITE_ORDER';
export const SET_FAVOURITE_ORDER_SUCCESS = 'SET_FAVOURITE_ORDER_SUCCESS';
export const SET_FAVOURITE_ORDER_FAILURE = 'SET_FAVOURITE_ORDER_FAILURE';
export const DELETE_FAVOURITE_ORDER = 'DELETE_FAVOURITE_ORDER';
export const DELETE_FAVOURITE_ORDER_SUCCESS = 'DELETE_FAVOURITE_ORDER_SUCCESS';
export const DELETE_FAVOURITE_ORDER_FAILURE = 'DELETE_FAVOURITE_ORDER_FAILURE';
export const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
export const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS';
export const GET_ORDER_HISTORY_FAILURE = 'GET_ORDER_HISTORY_FAILURE';
export const GET_ACTIVE_ORDER_HISTORY = 'GET_ACTIVE_ORDER_HISTORY';
export const GET_ACTIVE_ORDER_HISTORY_SUCCESS = 'GET_ACTIVE_ORDER_HISTORY_SUCCESS';
export const GET_ACTIVE_ORDER_HISTORY_FAILURE = 'GET_ACTIVE_ORDER_HISTORY_FAILURE';
export const RESET_ACTIVE_ORDER_HISTORY = 'RESET_ACTIVE_ORDER_HISTORY';
export const CLEAR_GIFTCARD_BALANCE = 'CLEAR_GIFTCARD_BALANCE';
export const RESET_GIFTCARDBALANCE = 'RESET_GIFTCARDBALANCE';
export const RESET_GIFT_CARD_TRANSACTION = 'RESET_GIFT_CARD_TRANSACTION';
export const PAYMENT_USING_PHONEPE = 'PAYMENT_USING_PHONEPE';
export const PAYMENT_USING_PHONEPE_SUCCESS = 'PAYMENT_USING_PHONEPE_SUCCESS';
export const PAYMENT_USING_PHONEPE_FAILURE = 'PAYMENT_USING_PHONEPE_FAILURE';
export const PAYMENT_USING_GOOGLEPAY = 'PAYMENT_USING_GOOGLEPAY';
export const PAYMENT_USING_GOOGLEPAY_SUCCESS = 'PAYMENT_USING_GOOGLEPAY_SUCCESS';
export const PAYMENT_USING_GOOGLEPAY_FAILURE = 'PAYMENT_USING_GOOGLEPAY_FAILURE';
export const PHONEPE_STATUS_CHECK = 'PHONEPE_STATUS_CHECK';
export const PHONEPE_STATUS_CHECK_SUCCESS = 'PHONEPE_STATUS_CHECK_SUCCESS';
export const PHONEPE_STATUS_CHECK_FAILURE = 'PHONEPE_STATUS_CHECK_FAILURE';
export const API_ERROR = 'API_ERROR';
export const ERROR_CODE = 'ERROR_CODE';
export const ERROR_MSG = 'ERROR_MSG';
export const PAYTM_STATUS_CHECK = 'PAYTM_STATUS_CHECK';
export const PAYTM_STATUS_CHECK_SUCCESS = 'PAYTM_STATUS_CHECK_SUCCESS';
export const PAYTM_STATUS_CHECK_FAILURE = 'PAYTM_STATUS_CHECK_FAILURE';
export const SET_SPLASHSCREEN_VIEW = 'SET_SPLASHSCREEN_VIEW';
export const SET_SMART_BANNER = 'SET_SMART_BANNER';
export const FETCH_OTHER_WALLETS_LIST = 'FETCH_OTHER_WALLETS_LIST';
export const FETCH_OTHER_WALLETS_LIST_SUCCESS = 'FETCH_OTHER_WALLETS_LIST_SUCCESS';
export const FETCH_OTHER_WALLETS_LIST_FAILURE = 'FETCH_OTHER_WALLETS_LIST_FAILURE';
export const QR_CODE_SCAN_TIME = 'QR_CODE_SCAN_TIME';
export const ANALYTICS_DATA_PERSIST = 'ANALYTICS_DATA_PERSIST';
export const TAB_REFRESH = 'TAB_REFRESH';
export const UPDATE_BASKET_FLAG = 'UPDATE_BASKET_FLAG';
export const ADD_PROMO_CODE = 'ADD_PROMO_CODE';
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE';
export const ADD_EMPLOYEE_PROMO_CODE = 'ADD_EMPLOYEE_PROMO_CODE';
export const REMOVE_EMPLOYEE_PROMO_CODE = 'REMOVE_EMPLOYEE_PROMO_CODE';
export const REMOVE_ALL_PROMOS = 'REMOVE_ALL_PROMOS';
export const SET_PROMOS = 'SET_PROMOS';
export const SETLOCATION_HOME_NAVIGATION = 'SETLOCATION_HOME_NAVIGATION';
export const FETCH_CASH_TRANSCATION_ID = 'FETCH_CASH_TRANSCATION_ID';
export const FETCH_CASH_TRANSCATION_ID_SUCCESS = 'FETCH_CASH_TRANSCATION_ID_SUCCESS';
export const FETCH_CASH_TRANSCATION_ID_FAILURE = 'FETCH_CASH_TRANSCATION_ID_FAILURE';
export const VALIDATE_ORDER_REQUEST = 'VALIDATE_ORDER_REQUEST';
export const VALIDATE_ORDER_SUCCESS = 'VALIDATE_ORDER_SUCCESS';
export const VALIDATE_ORDER_FAILURE = 'VALIDATE_ORDER_FAILURE';
export const SET_STORE_PLACE_ID = 'SET_STORE_PLACE_ID';
/**
 * Micro App ActionTypes
 */
export const MINI_APP_CONSTANTS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
    PENDING: 'pending',
    API_RETRY_COUNT: 3,
    STATUS_DELAY_TIME: 5000,
};
export const GOOGLE_SPOT = {
    RESET_PAYMENTS: 'GOOGLE_SPOT_RESET_PAYMENTS',
    INITIATE_PAYMENT_REQUEST: 'GOOGLE_SPOT_INITIATE_PAYMENT_REQUEST',
    INITIATE_PAYMENT_REQUEST_SUCCESS: 'GOOGLE_SPOT_INITIATE_PAYMENT_REQUEST_SUCCESS',
    INITIATE_PAYMENT_REQUEST_FAILURE: 'GOOGLE_SPOT_INITIATE_PAYMENT_REQUEST_FAILURE',
    VALIDATE_RESPONSE: 'GOOGLE_SPOT_VALIDATE_RESPONSE',
    VALIDATE_RESPONSE_SUCCESS: 'GOOGLE_SPOT_VALIDATE_RESPONSE_SUCCESS',
    VALIDATE_RESPONSE_FAILURE: 'GOOGLE_SPOT_VALIDATE_RESPONSE_FAILURE',
    CHECK_TRANSACTION_STATUS: 'GOOGLE_SPOT_CHECK_TRANSACTION_STATUS',
    CHECK_TRANSACTION_STATUS_SUCCESS: 'GOOGLE_SPOT_CHECK_TRANSACTION_STATUS_SUCCESS',
    CHECK_TRANSACTION_STATUS_FAILURE: 'GOOGLE_SPOT_CHECK_TRANSACTION_STATUS_FAILURE',
};
export const ANALYTICS_UNIQUE_IDENTIFIERS = {
    PHONE_NUMBER: 'PHONE_NUMBER',
    EMAIL: 'EMAIL',
};
export const PAYTM_MINIAPP_INITIATE_TRANSACTION = 'PAYTM_MINIAPP_INITIATE_TRANSACTION';
export const PAYTM_MINIAPP_INITIATE_TRANSACTION_SUCCESS = 'PAYTM_MINIAPP_INITIATE_TRANSACTION_SUCCESS';
export const PAYTM_MINIAPP_INITIATE_TRANSACTION_FAILURE = 'PAYTM_MINIAPP_INITIATE_TRANSACTION_FAILURE';
export const PAYTM_MINIAPP_STATUS_CHECK = 'PAYTM_MINIAPP_STATUS_CHECK';
export const PAYTM_MINIAPP_STATUS_CHECK_SUCCESS = 'PAYTM_MINIAPP_STATUS_CHECK_SUCCESS';
export const PAYTM_MINIAPP_STATUS_CHECK_FAILURE = 'PAYTM_MINIAPP_STATUS_CHECK_FAILURE';
export const MINIAPP_PAYMENT_STATUS_RESET = 'MINIAPP_PAYMENT_STATUS_RESET';
export const PHONEPE_SWITCH_INITIATE_TRANSACTION = 'PHONEPE_SWITCH_INITIATE_TRANSACTION';
export const PHONEPE_SWITCH_INITIATE_TRANSACTION_SUCCESS = 'PHONEPE_SWITCH_INITIATE_TRANSACTION_SUCCESS';
export const PHONEPE_SWITCH_INITIATE_TRANSACTION_FAILURE = 'PHONEPE_SWITCH_INITIATE_TRANSACTION_FAILURE';
export const PHONEPE_SWITCH_STATUS_CHECK = 'PHONEPE_SWITCH_STATUS_CHECK';
export const PHONEPE_SWITCH_STATUS_CHECK_SUCCESS = 'PHONEPE_SWITCH_STATUS_CHECK_SUCCESS';
export const PHONEPE_SWITCH_STATUS_CHECK_FAILURE = 'PHONEPE_SWITCH_STATUS_CHECK_FAILURE';
export const SET_SELECTED_VIEW_MODE = 'SET_SELECTED_VIEW_MODE';
export const GIFTCARD_PURCHASE_STATUS = 'GIFTCARD_PURCHASE_STATUS';
export const GIFTCARD_PURCHASE_STATUS_SUCCESS = 'GIFTCARD_PURCHASE_STATUS_SUCCESS';
export const GIFTCARD_PURCHASE_STATUS_FAIL = 'GIFTCARD_PURCHASE_STATUS_FAIL';
export const RESET_PURCHASE_STATUS = 'RESET_PURCHASE_STATUS';
export const RESET_ORDER_HISTORY = 'RESET_ORDER_HISTORY';
export const CLEAR_REDUX_STORE = 'CLEAR_REDUX_STORE';
export const REORDER_STORE_STATUS = 'REORDER_STORE_STATUS';
export const REORDER_STORE_STATUS_SUCCESS = 'REORDER_STORE_STATUS_SUCCESS';
export const REORDER_STORE_STATUS_ERROR = 'REORDER_STORE_STATUS_ERROR';
export const REORDER_FETCH_MENU = 'REORDER_FETCH_MENU';
export const REORDER_FETCH_MENU_SUCCESS = 'REORDER_FETCH_MENU_SUCCESS';
export const REORDER_FETCH_MENU_ERROR = 'REORDER_FETCH_MENU_ERROR';
export const TENDER_DATA_SET = 'TENDER_DATA_SET';
export const RE_ORDER_ACCEPTED_ERROR = 'RE_ORDER_ACCEPTED_ERROR';
export const RE_ORDER_ACCEPTED = 'RE_ORDER_ACCEPTED';
export const RE_ORDER_ACCEPTED_SUCCESS = 'RE_ORDER_ACCEPTED_SUCCESS';
export const RESET_STORE_DETAILS = 'RESET_STORE_DETAILS';
export const RESET_RESTAURANT_DETAILS = 'RESET_RESTAURANT_DETAILS';
export const REORDER_UPDATE_DELIVERY = 'REORDER_UPDATE_DELIVERY';
export const HEADER_REQUEST_ID = 'x-correlation-request-id';
export const HEADER_SESSION_ID = 'x-correlation-session-id';
export const MEDIA_TYPE_APPLICATION_JSON = 'application/json';
export const API_REQUEST_TIMEOUT_DEFAULT_SEC = 30;
export const GET_WEB_APP_VERSION = 'GET_WEB_APP_VERSION';
export const APP_VERSION_API_SUCCESS = 'APP_VERSION_API_SUCCESS';
export const APP_VERSION_API_ERROR = 'APP_VERSION_API_ERROR';
export const HIDE_OCCASION_TOAST = 'HIDE_OCCASION_TOAST';
export const CUSTOMER_ID_UPDATED = 'CUSTOMER_ID_UPDATED';
export const ADD_ITEM_QUANTITY = 'ADD_ITEM_QUANTITY';
export const RESET_ITEM_QUANTITY = 'RESET_ITEM_QUANTITY';
export const BULK_UPDATE_ITEM_QUANTITY = 'BULK_UPDATE_ITEM_QUANTITY';
export const SET_DISPOSITION = 'SET_DISPOSITION';
export const RESET_DISPOSITION = 'RESET_DISPOSITION';
export const GET_PLP_DISCLAIMER = 'GET_PLP_DISCLAIMER';
export const PLP_DISCLAIMER_ERROR = 'PLP_DISCLAIMER_ERROR';
export const PLP_DISCLAIMER_SUCCESS = 'PLP_DISCLAIMER_SUCCESS';
export const UPDATE_CUSTOMER_ID_ORDER = 'UPDATE_CUSTOMER_ID_ORDER';
export const UPDATE_CUSTOMER_ID_ORDER_SUCCESS = 'UPDATE_CUSTOMER_ID_ORDER_SUCCESS';
export const UPDATE_CUSTOMER_ID_ORDER_FAILURE = 'UPDATE_CUSTOMER_ID_ORDER_FAILURE';
export const SHOW_DISPOSITION_MODAL = 'SHOW_DISPOSITION_MODAL';
export const SHOW_SECRET_MENU = 'SHOW_SECRET_MENU';
export const SECRET_MENU_EXPIRE = 'SECRET_MENU_EXPIRE';
export const RESET_SECRET_MENU_EXPIRY = 'RESET_SECRET_MENU_EXPIRY';
export const GENERATE_CLIENT_TOKEN = 'GENERATE_CLIENT_TOKEN';
export const GENERATE_CLIENT_TOKEN_SUCCESS = 'GENERATE_CLIENT_TOKEN_SUCCESS';
export const GENERATE_CLIENT_TOKEN_FAILURE = 'GENERATE_CLIENT_TOKEN_FAILURE';
export const RESET_BRAINTREE_REDUCER = 'RESET_BRAINTREE_REDUCER';
export const SET_ADDITIONAL_ADDRESS = 'SET_ADDITIONAL_ADDRESS';
export const SET_STATE_FOR_SELECTKFC = 'SET_STATE_FOR_SELECTKFC';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
//transaction sale
export const SET_FETCH_RECENT_PAYMENT_METHOD_LOADER = 'SET_FETCH_RECENT_PAYMENT_METHOD_LOADER';
export const TRANSACTION_SALE = 'TRANSACTION_SALE';
export const TRANSACTION_SALE_SUCCESS = 'TRANSACTION_SALE_SUCCESS';
export const TRANSACTION_SALE_FAILURE = 'TRANSACTION_SALE_FAILURE';
export const BRAINTREE_RESPONSE = 'BRAINTREE_RESPONSE';
//transaction submit
export const TRANSACTION_SUBMIT = 'TRANSACTION_SUBMIT';
export const TRANSACTION_SUBMIT_SUCCESS = 'TRANSACTION_SUBMIT_SUCCESS';
export const TRANSACTION_SUBMIT_FAILURE = 'TRANSACTION_SUBMIT_FAILURE';
//transaction void
export const TRANSACTION_VOID = 'TRANSACTION_VOID';
export const TRANSACTION_VOID_SUCCESS = 'TRANSACTION_VOID_SUCCESS';
export const TRANSACTION_VOID_FAILURE = 'TRANSACTION_VOID_FAILURE';
export const UPDATE_CART_WITH_STORE_AND_DISPOSITION = 'UPDATE_CART_WITH_STORE_AND_DISPOSITION';
export const UPDATE_CART_WITH_STORE_AND_DISPOSITION_SUCCESS = 'UPDATE_CART_WITH_STORE_AND_DISPOSITION_SUCCESS';
export const UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE = 'UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE';
export const SET_CART_AS_NON_DIRTY = 'SET_CART_AS_NON_DIRTY';
export const REORDER_SELECTED_DISPOSITION = 'REORDER_SELECTED_DISPOSITION';
export const SET_REORDER = 'SET_REORDER';
export const REORDER_STORE_DISPOSITION = 'REORDER_STORE_DISPOSITION';
export const ITEM_ADD_HOPE = 'Add Hope';
export const ITEM_CARRY_BAG = 'Carry Bag';
// Autodetect
export const SET_ROOT = 'SET_ROOT';
export const SET_STORE_OPENTIME_CLOSEDTIME = 'SET_STORE_OPENTIME_CLOSEDTIME';
export const USER_LOCATION = 'USER_LOCATION';
export const STORE_LOCATION_SUCCESS = 'STORE_LOCATION_SUCCESS';
export const USER_LOCATION_DENIED = 'USER_LOCATION_DENIED';
export const RESET_USER_LOCATION = 'RESET_USER_LOCATION';
export const UNLOCK_SECRET_MENU = 'UNLOCK_SECRET_MENU';
export const GET_STORES_DETAILS_CONTENT_FULL = 'GET_STORES_DETAILS_CONTENT_FULL';
export const GET_STORES_DETAILS_CONTENT_FULL_SUCCESS = 'GET_STORES_DETAILS_CONTENT_FULL_SUCCESS';
export const GET_STORES_DETAILS_CONTENT_FULL_FAILURE = 'GET_STORES_DETAILS_CONTENT_FULL_FAILURE';
export const SET_ON_FIND_A_KFC_PAGE = 'SET_ON_FIND_A_KFC_PAGE';
export const SET_STORE_UN_FAVOURITE_SUCCESS = 'SET_STORE_UN_FAVOURITE_SUCCESS';
export const SET_STORE_UN_FAVOURITE_ERROR = 'SET_STORE_UN_FAVOURITE_ERROR';
export const SET_STORE_FAVOURITE_SUCCESS = 'SET_STORE_FAVOURITE_SUCCESS';
export const SET_STORE_FAVOURITE_ERROR = 'SET_STORE_FAVOURITE_ERROR';
export const SET_ON_PRE_45_MIN_POPUP_SCREENCHECK = 'SET_ON_PRE_45_MIN_POPUP_SCREENCHECK';
export const TOGGLE_SECRET_MENU = 'TOGGLE_SECRET_MENU';
export const REGISTER_NATIVE_HEIGHT = 'REGISTER_NATIVE_HEIGHT';
export const USER_LOCATION_ACCESS_STATUS = 'USER_LOCATION_ACCESS_STATUS';
export const PLP_NAVIGATION_PARAM = 'PLP_NAVIGATION_PARAM';
export const CLEAR_PLP_NAVIGATION_PARAM = 'CLEAR_PLP_NAVIGATION_PARAM';
export const RESET_STORE_DATA = 'RESET_STORE_DATA';
export const ERRORPOPUP_NAVIGATION_TO_BACK = 'ERRORPOPUP_NAVIGATION_TO_BACK';
export const PLACE_ORDER_LOADING = 'PLACE_ORDER_LOADING';
export const X_AKAMAI_ORIGIN = 'x-akamai-origin';
export const KFC_RENEGADE_GOOGLE_PLACES = 'kfc-renegade-google-places';
// Global payment
export const GLOBALPAYMENTS_GENERATE_TOKEN = 'GLOBALPAYMENTS_GENERATE_TOKEN';
export const GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE = 'GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE';
export const GLOBALPAYMENTS_GENERATE_TOKEND_SUCCESS = 'GLOBALPAYMENTS_GENERATE_TOKEND_SUCCESS';
export const GLOBALPAYMENTS_INITIATE_PAYMENT_CALL = 'GLOBALPAYMENTS_INITIATE_PAYMENT_CALL';
export const GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_SUCCESS = 'GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_SUCCESS';
export const GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED = 'GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED';
export const GLOBALPAYMENTS_VALIDATE_ADDRESSS = 'GLOBALPAYMENTS_VALIDATE_ADDRESSS';
export const GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE = 'GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE';
export const GLOBALPAYMENTS_VALIDATE_ADDRESSS_SUCCESS = 'GLOBALPAYMENTS_VALIDATE_ADDRESSS_SUCCESS';
export const CHECKOUT_DISPOSTION_OPTIONS_INFO = {
    HAND_IT_TO_ME: 'handittome',
    LEAVE_AT_MY_DOOR: 'leaveatmydoor',
};
export const GLOBALPAYMENT_SAVE_CARD = 'GLOBALPAYMENT_SAVE_CARD';
export const GLOBALPAYMENT_SAVE_CARD_SUCCESS = 'GLOBALPAYMENT_SAVE_CARD_SUCCESS';
export const GLOBALPAYMENT_SAVE_CARD_FAILUR = 'GLOBALPAYMENT_SAVE_CARD_FAILUR';
export const PAYMENT_FOR_GIFTCARD = 'PAYMENT_FOR_GIFTCARD';
export const PAYMENT_FOR_GIFTCARD_SUCCESS = 'PAYMENT_FOR_GIFTCARD_SUCCESS';
export const PAYMENT_FOR_GIFTCARD_FAILURE = 'PAYMENT_FOR_GIFTCARD_FAILURE';
export const GLOBALPAYMENT_IS_STORE_3DS_ENABLED = 'GLOBALPAYMENT_IS_STORE_3DS_ENABLED';
export const GLOBALPAYMENT_IS_STORE_3DS_ENABLED_SUCCESS = 'GLOBALPAYMENT_IS_STORE_3DS_ENABLED_SUCCESS';
export const GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE = 'GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE';
export const GLOBALPAYMENT_VERIFY_CARD = 'GLOBALPAYMENT_VERIFY_CARD';
export const GLOBALPAYMENT_VERIFY_CARD_SUCCESS = 'GLOBALPAYMENT_VERIFY_CARD_SUCCESS';
export const GLOBALPAYMENT_VERIFY_CARD_FAILURE = 'GLOBALPAYMENT_VERIFY_CARD_FAILURE';
export const ADYEN_PAYMENT_METHODS_REQUEST = 'ADYEN_PAYMENT_METHODS_REQUEST';
export const ADYEN_PAYMENT_METHODS_RESET = 'ADYEN_PAYMENT_METHODS_RESET';
export const SUBMIT_ADYEN_PAYMENT_REQUEST = 'SUBMIT_ADYEN_PAYMENT_REQUEST';
export const SUBMIT_ADYEN_PAYMENT_RESET = 'SUBMIT_ADYEN_PAYMENT_RESET';
export const SUBMIT_ADDITIONAL_ADYEN_PAYMENT_REQUEST = 'SUBMIT_ADDITIONAL_ADYEN_PAYMENT_REQUEST';
export const SUBMIT_ADDITIONAL_ADYEN_PAYMENT_RESET = 'SUBMIT_ADDITIONAL_ADYEN_PAYMENT_RESET';
export const REMOVE_ADYEN_STORED_PAYMENT_REQUEST = 'REMOVE_ADYEN_STORED_PAYMENT_REQUEST';
export const REMOVE_ADYEN_STORED_PAYMENT_RESET = 'REMOVE_ADYEN_STORED_PAYMENT_RESET';
//Dgft Payment
export const DGFT_CREDITCARD_GENERATE_TOKEN = 'DFGT_CREDITCARD_GENERATE_TOKEN';
export const DGFT_CREDITCARD_GENERATE_TOKEND_SUCCESS = 'DFGT_CREDITCARD_GENERATE_TOKEND_SUCCESS';
export const DGFT_CREDITCARD_GENERATE_TOKEND_FAILURE = 'DFGT_CREDITCARD_GENERATE_TOKEND_FAILURE';
export const DGFT_APPLEPAY_GENERATE_TOKEN = 'DFGT_APPLEPAY_GENERATE_TOKEN';
export const DGFT_APPLEPAY_GENERATE_TOKEN_SUCCESS = 'DFGT_APPLEPAY_GENERATE_TOKEND_SUCCESS';
export const DGFT_APPLEPAY_GENERATE_TOKEN_FAILURE = 'DFGT_APPLEPAY_GENERATE_TOKEND_FAILURE';
export const DGFT_PAYMENT_AUTHORIZE_CALL = 'DGFT_PAYMENT_AUTHORIZE_CALL';
export const DGFT_PAYMENT_AUTHORIZE_SUCCESS = 'DGFT_PAYMENT_AUTHORIZE_SUCCESS';
export const DGFT_PAYMENT_AUTHORIZE_FAILED = 'DGFT_PAYMENT_AUTHORIZE_FAILED';
// Japan Payment Requested API
export const PAYMENT_REQUESTED_CALL = 'PAYMENT_REQUESTED_CALL';
export const PAYMENT_REQUESTED_SUCCESS = 'PAYMENT_REQUESTED_SUCCESS';
export const PAYMENT_REQUESTED_FAILED = 'PAYMENT_REQUESTED_FAILED';
export const GIFTCARD_BALANCE_CALL = 'GIFTCARD_BALANCE_CALL';
export const GIFTCARD_BALANCE_SUCCESS = 'GIFTCARD_BALANCE_SUCCESS';
export const GIFTCARD_BALANCE_FAILED = 'GIFTCARD_BALANCE_FAILED';
// Japan Dgft Saved CardDetails
export const DGFT_GET_SAVED_CARD_CALL = 'DGFT_GET_SAVED_CARD_CALL';
export const DGFT_GET_SAVED_CARD_SUCCESS = 'DGFT_GET_SAVED_CARD_SUCCESS';
export const DGFT_GET_SAVED_CARD_FAILED = 'DGFT_GET_SAVED_CARD_FAILED';
export const DGFT_DELETE_SAVED_CARD_CALL = 'DGFT_DELETE_SAVED_CARD_CALL';
export const DGFT_DELETE_SAVED_CARD_SUCCESS = 'DGFT_DELETE_SAVED_CARD_SUCCESS';
export const DGFT_DELETE_SAVED_CARD_FAILED = 'DGFT_DELETE_SAVED_CARD_FAILED';
export const GET_OFFLINE_COUPONS = 'GET_OFFLINE_COUPONS';
export const USE_OFFLINE_COUPONS = 'USE_OFFLINE_COUPONS';
export const SET_SELECTED_COUPON = 'SET_SELECTED_COUPON';
export const GET_OFFLINE_COUPONS_SUCCESS = 'GET_OFFLINE_COUPONS_SUCCESS';
export const GET_OFFLINE_COUPONS_ERROR = 'GET_OFFLINE_COUPONS_ERROR';
export const USE_OFFLINE_COUPONS_ERROR = 'USE_OFFLINE_COUPONS_ERROR';
export const SHOW_OFFLINE_COUPON_CONTENT = 'SHOW_OFFLINE_COUPON_CONTENT';
export const GET_HIDDEN_COUPON_DETAILS = 'GET_HIDDEN_COUPON_DETAILS';
export const GET_HIDDEN_COUPON_SUCCESS = 'GET_HIDDEN_COUPON_SUCCESS';
export const GET_HIDDEN_COUPON_ERROR = 'GET_HIDDEN_COUPON_ERROR';
